import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type Category = {
  id: string;
  parent_id: string | null;
  name: string;
  status: string | null;
};

export function useCategories() {
  const { token } = useAuth();
  const [rows, setRows] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!token) {
      setRows([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await api.categories.list({ token });
      setRows(res.data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load categories");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { categories: rows, loading, error, reload };
}

